<header
  class="bcledger-header d-flex align-items-center justify-content-between has-border mb-2">
  <h2 class="mb-0">Freight Charges</h2>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <jni-spinner></jni-spinner>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <p-button
      label="Export Excel"
      variant="outlined"
      icon="pi pi-cloud-upload"
      severity="secondary"
      (click)="exportExcelFile()"
      class="fullwdth secondary-btn" />
  </div>

  <span *ngIf="isModal" class="mx-3" (click)="closeTrackingListModal()"
    ><i class="pi pi-times"></i
  ></span>
</header>

<div>
  <p-table
    #dt
    stripedRows
    [size]="'small'"
    styleClass="table-listing"
    responsiveLayout="scroll"
    [value]="FreightChargesLists"
    [rowHover]="true"
    [rows]="20"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [autoLayout]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 310px)"
    [paginator]="true"
    [resizableColumns]="true"
    [paginator]="FreightChargesLists.length >= 20">
    <ng-template pTemplate="caption">
      <div class="d-flex align-items-center">
        <!--<ng-container>
          <div class="form-group has-float-label me-2 px-2">
            <input
              class="form-control filter me-2 text-end"
              type="text"
              [value]="totalFreightCost | number: '1.2-2'"
              disabled
            />
            <label class="form-label">Total Freight Cost</label>
          </div>
          <div class="form-group has-float-label me-2">
            <input
              class="form-control filter me-2 text-end"
              type="text"
              [value]="totalFreightRetail | number: '1.2-2'"
              disabled
            />
            <label class="form-label">Total Freight Retail</label>
          </div>
          <div class="form-group has-float-label me-2">
            <input
              class="form-control filter me-2 text-end"
              type="text"
              [value]="totalFreightSell | number: '1.2-2'"
              disabled
            />
            <label class="form-label">Total Freight Sell</label>
          </div>
          <div class="form-group has-float-label me-2">
            <input
              class="form-control filter me-2 text-end"
              type="text"
              [value]="totalProcessingfees | number: '1.2-2'"
              disabled
            />
            <label class="form-label">Total Processing Fees</label>
          </div>
          <div class="form-group has-float-label me-2">
            <input
              class="form-control filter me-2 text-end"
              type="text"
              [value]="totalBilledCharge | number: '1.2-2'"
              disabled
            />
            <label class="form-label">Total Billed Charges</label>
          </div>
          <div class="form-group has-float-label me-2">
            <input
              class="form-control filter me-2 text-end"
              type="text"
              [value]="totalTaxCredit | number: '1.2-2'"
              disabled
            />
            <label class="form-label">Total Tax Credits</label>
          </div> 
        </ng-container>-->
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="table-head">
        <!-- <th>Charges Code</th> -->
        <th style="width: 6rem">
          Charges Code
          <p-columnFilter
            type="text"
            field="chargesCode"
            display="menu"></p-columnFilter>
        </th>
        <th>Description</th>
        <th>Amount</th>
        <th>Reference</th>
        <th>BC Ledger</th>
        <th>Number</th>
        <th>Freight Bill #</th>
        <th>Tracking</th>
        <th>Created by</th>
        <th>Created date and time</th>
        <th>Modified by</th>
        <th>Modified date and time</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="chargesCode"
              id="chargesCode"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'chargesCode',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="description"
              id="description"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'description',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="chargesValue"
              id="chargesValue"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'chargesValue',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="reference"
              id="reference"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'reference', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="projectId"
              id="projectId"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'projectId', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="number"
              id="number"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'number', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="freightBill"
              id="freightBill"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'freightBill',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="trackingNumber"
              id="trackingNumber"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'trackingNumber',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="createdBy"
              id="createdBy"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'createdBy', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="modifiedBy"
              id="modifiedBy"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'modifiedBy', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-FreightChargesList
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="FreightChargesList"
        [pSelectableRowIndex]="rowIndex">
        <td>{{ FreightChargesList.chargesCode }}</td>
        <td>{{ FreightChargesList.description }}</td>
        <td style="text-align: right">
          {{
            FreightChargesList.chargesValue
              | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>
        <td>{{ FreightChargesList.reference }}</td>
        <td>{{ FreightChargesList.projectId }}</td>
        <td>{{ FreightChargesList.number }}</td>
        <td>
          {{ FreightChargesList.freightBill }}
        </td>
        <td>
          <a
            class="link"
            (click)="
              onTrackingNumberSelection(FreightChargesList?.trackingNumber)
            ">
            {{ FreightChargesList.trackingNumber }}</a
          >
        </td>
        <td>
          {{ FreightChargesList.createdBy }}
        </td>
        <td>
          {{ FreightChargesList.createdDateTime | date: "MM-dd-yyyy" }}
        </td>
        <td>
          {{ FreightChargesList.modifiedBy }}
        </td>
        <td>
          {{ FreightChargesList.modifiedDateTime | date: "MM-dd-yyyy" }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="30">No Data Found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style="text-align: center">
          {{ totalAmount | currency: "USD" : "symbol" : "1.2-2" }}
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-modal-stacker
  *ngIf="orderTrackingDisplayModal"
  [displayModal]="orderTrackingDisplayModal"
  (closeEvent)="closeModalFromOrderTracking()">
  <h1 class="panelHeading d-flex">Freight Details</h1>
  <div class="panelBody">
    <jni-freight-details
      [isModal]="true"
      [trackingNumber]="trackingNumber"
      (closeEvent)="closeModalFromOrderTracking()"></jni-freight-details>
  </div>
</jni-modal-stacker>
